







































































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

import rtSelect from "@/components/couponcancel/rtSelect.vue";
import rtDatePicker from "@/components/couponcancel/rtDatePicker.vue";

const couponModule = namespace("coupon");
const couponCategoryObj: any = {
  "0": "折扣券",
  "1": "礼品券",
  "2": "代金券",
  // '6': '免费试吃试用',
  // '7': '单品优惠',
  // '8': '品牌活动',
  "9": "通用券",
  // '10': '停车券',
  // '11': '企业付款红包',
  // '12': '预充值代金劵',
  "13": "立减券"
};
// couponcancel
@Component({
  components: {
    rtSelect,
    rtDatePicker
  }
})
export default class CouponCancel extends Vue {
  // @couponModule.State("couponCancelList") list!: any;
  // @couponModule.State("couponCancelPage") pages!: any;
  @couponModule.State("couponCategoryList") categoryList!: any;
  // @couponModule.State("couponCancelPageLoading")
  // couponCancelPageLoading!: boolean;

  couponKeyword: string = ""; /* 输入搜索 */
  couponType: string = ""; /* 券类型 */
  couponName: string = ""; /* 券名称 */
  couponInstanceQrCode: string = ""; /* 券码 */
  searchWriteOffDateStart: string = ""; /** 核销开始时间*/
  searchWriteOffDateEnd: string = ""; /** 核销结束时间*/
  selfStatus: boolean = false;

  finished: boolean = false;
  loading: boolean = false;
  error: boolean = false;
  pages: any = {
    finished: false,
    loading: false,
    total: 0,
    pageNum: 1,
    pageSize: 10,
    couponAvailableList: []
  };

  @Watch("$route", { immediate: true })
  private changeRouter(route: any) {
    this.$store.commit("coupon/clearCouponCancelList");
    this.$store.commit("coupon/setcancelPage", 1);
  }

  // get loadingShow() {
  //   return this.loading;
  // }
  // set loadingShow(newVal) {
  //   this.loading = this.couponCancelPageLoading;
  // }
  mounted() {
    // this.getCouponEntityList();
  }
  // getData() {
  //     this.getCouponEntityList();
  // }
  getCouponEntityList(pageNum?: number) {
    let self = this;
    self.$store
      .dispatch("giftCard/getWriteoffNotRefundList", {
        giftCardFlowBusinessEntityId: this.$global.tenantId /**主体id*/,
        mobile: self.couponInstanceQrCode /**手机号 */,
        startTime:
          self.searchWriteOffDateStart /** 核销开始时间*/,
        endTime: self.searchWriteOffDateEnd /** 核销结束时间*/,
        pageNum: pageNum || self.pages.pageNum || 1,
        pageSize: self.pages.pageSize,
      })
      .then(({ success, error }) => {
        if (success) {
          self.pages.total = success.data.total||0;
          self.pages.loading = false;
          console.log(success.data.list);
          const _list = success.data.list||[]
          if (self.pages.pageNum >= success.data.pages) {
            self.finished = true;
          }
          self.pages.pageNum = self.pages.pageNum + 1;
          self.pages.couponAvailableList = [
            ...self.pages.couponAvailableList,
            ..._list
          ];
        } else {
          self.pages.loading = false;
          self.error = true;
          this.$notify({ type: "warning", message: error.msg });
        }
      });

    // debugger;
    // if (success) {
    //   if (success.data.pages == success.data.pageNum) {
    //     this.finished = true;
    //   }
    //   this.loading = false;
    // }
  }
  handleStartDate(value: string) {
    this.searchWriteOffDateStart = value;
    this.pages.pageNum = 1;
    this.renderGetData();
  }
  handleEndDate(value: string) {
    this.searchWriteOffDateEnd = value;
    this.pages.pageNum = 1;
    this.renderGetData();
  }
  handleSearchInput() {
    const keyword = parseInt(this.couponKeyword);
    // if (keyword + "" === this.couponKeyword) {
      this.couponInstanceQrCode = this.couponKeyword;
    //   this.couponName = "";
    // } else {
    //   this.couponInstanceQrCode = "";
    //   this.couponName = this.couponKeyword;
    // }
    this.pages.pageNum = 1;
    this.renderGetData();
  }
  handleSelectTypeClick(item: string) {
    this.couponType = item;
    this.pages.pageNum = 1;
    this.renderGetData();
  }
  renderFinished() {
    this.finished = false;
  }
  renderGetData() {
    this.pages.couponAvailableList = [];
    this.selfStatus = true;
    this.renderFinished();
    // this.getCouponEntityList();
    this.selfStatus = false;
  }
  onLoadList() {
    console.log(this.selfStatus);
    // if(!this.selfStatus){
    //   return ;
    // }
    this.getCouponEntityList();
  }
  handleDetailClick(item: any) {
    console.log(item);
    
    this.$router.push({ path: `/writeoffLog/detail`, query: {id:item.giftCardFlowId} });
  }
}
